<div class="row">
    <div class="col-sm-12">
        <h3 mat-dialog-title>
            <span class="bold">{{data.currency ? 'Edit' : 'Create'}} currency</span>
        </h3>
    </div>
</div>

<div mat-dialog-content>
    <div class="row contenido-modal">
        <div class="col-md-12">
            <p class="descripcion-modal">Ingrese los campos para {{ data.currency ? 'editar' : 'crear'}} una currency:</p>
        </div>
        <div class="col-sm-12">
            <app-currency-form
                    (validCurrency)="validarFormulario($event)"
                    [currency]="data.currency"
                    [countries]="data.countries"
            >
            </app-currency-form>
        </div>
    </div>
</div>

<mat-dialog-actions class="justify-content-end">
    <div class="d-flex flex-row-reverse">
        <div class="p-2">
            <button class="btn btn-primary" (click)="createEditMethod()" [disabled]="!validForm">SAVE
            </button>
        </div>
        <div class="p-2">
            <button mat-dialog-close class="btn btn-outline-secondary">CANCEL</button>
        </div>
    </div>
</mat-dialog-actions>

